import type { RouteObject } from "react-router-dom";
import ImportsLandingPage from "./List";
import ImportDiffPage, { importDiffLoader } from "./Diff";
import ImportHistoryPage, { importHistoryLoader } from "./History";
import AppError from "../app-error";

/**
 * US5 (001, T085-T090). `/imports` and `/imports/:batchNumber` are both gated by `catalogue.administer` at the
 * root loader (`lib/nav.tsx`'s one `/imports` entry, `permissionForPath`'s prefix match) — there is
 * no way to give a dynamic `:batchNumber` segment a stricter permission than its parent through that
 * mechanism, so the stronger `catalogue.administer` needed for the commit/abandon actions themselves is
 * checked inside `Diff.tsx`, the same shape `inventory/Adjustments.tsx` already uses for an action
 * stricter than its own route's gate.
 */
export const importsRoutes: RouteObject[] = [
  { path: "imports", Component: ImportsLandingPage, errorElement: <AppError /> },
  // A static segment ranks above a dynamic one in React Router's own route scoring regardless of
  // array order, so this never falls through to ":batchNumber" below as a batch number.
  { path: "imports/history", Component: ImportHistoryPage, loader: importHistoryLoader, errorElement: <AppError /> },
  { path: "imports/:batchNumber", Component: ImportDiffPage, loader: importDiffLoader, errorElement: <AppError /> },
];
